export default {
    en: "English",
    bm: "Bahasa Malaysia"
  }